import { useMutation, useQueryClient } from '@tanstack/react-query'
import { InferenceAPI } from './utils'
import { toast } from 'react-hot-toast'
import {
  UpdateOrgUserProfileV2Args,
  UpdateOrgProfileRequest,
} from './inference.gen'

export const useUpdateUserProfile = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (args: UpdateOrgUserProfileV2Args) => {
      const result = await InferenceAPI.updateOrgUserProfileV2(args)

      queryClient.invalidateQueries({
        queryKey: ['get-org-user-profile'],
        exact: false,
      })
      toast.success('Profile updated successfully')
      return result.ok
    },
  })
}

export const useUpdateOrgProfile = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (args: UpdateOrgProfileRequest) => {
      const result = await InferenceAPI.updateOrgProfile({ args })

      // Invalidate both the organization profile and the user-orgs queries
      // to ensure complete refresh of organization data
      queryClient.invalidateQueries({
        queryKey: ['get-org-profile'],
        exact: false,
      })

      queryClient.invalidateQueries({
        queryKey: ['get-user-orgs'],
        exact: false,
      })

      queryClient.invalidateQueries({
        queryKey: ['get-org-user-profile'],
        exact: false,
      })

      toast.success('Organization profile updated successfully')
      return result.ok
    },
  })
}
